interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3 text-xs tracking-[0.25em] text-primary-600">
          <span className="font-heading font-bold">{index}</span>
          <span className="h-px w-8 bg-primary-300" />
          <span>{eyebrow}</span>
        </div>
        <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">{desc}</p>
        )}
      </div>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-secondary-700 hover:text-secondary-900 transition-colors cursor-pointer shrink-0"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </a>
      )}
    </div>
  );
}